import {Children, cloneElement, isValidElement, PropsWithChildren, ReactNode} from "react";

const capitalizeFirstLetter = (value: string): string => {
    const firstLetterIndex = value.search(/\p{L}/u);

    if (firstLetterIndex === -1) {
        return value;
    }

    return `${value.slice(0, firstLetterIndex)}${value.charAt(firstLetterIndex).toUpperCase()}${value.slice(firstLetterIndex + 1)}`;
};

export const capitalizeTextChildren = (children: ReactNode): ReactNode => {
    let hasCapitalizedFirstLetter = false;

    const processChildren = (nodes: ReactNode): ReactNode =>
        Children.map(nodes, (child) => {
            if (hasCapitalizedFirstLetter) {
                return child;
            }

            if (typeof child === "string") {
                const firstLetterIndex = child.search(/\p{L}/u);

                if (firstLetterIndex === -1) {
                    return child;
                }

                hasCapitalizedFirstLetter = true;

                return capitalizeFirstLetter(child);
            }

            if (!isValidElement<PropsWithChildren>(child) || child.props.children == null) {
                return child;
            }

            return cloneElement(child, undefined, processChildren(child.props.children));
        });

    return processChildren(children);
};
import {Children, cloneElement, isValidElement, PropsWithChildren, ReactNode} from "react";

const capitalizeFirstLetter = (value: string): string => {
    const firstLetterIndex = value.search(/\p{L}/u);

    if (firstLetterIndex === -1) {
        return value;
    }

    return `${value.slice(0, firstLetterIndex)}${value.charAt(firstLetterIndex).toUpperCase()}${value.slice(firstLetterIndex + 1)}`;
};

export const capitalizeTextChildren = (children: ReactNode): ReactNode => {
    let hasCapitalizedFirstLetter = false;

    const processChildren = (nodes: ReactNode): ReactNode =>
        Children.map(nodes, (child) => {
            if (hasCapitalizedFirstLetter) {
                return child;
            }

            if (typeof child === "string") {
                const firstLetterIndex = child.search(/\p{L}/u);

                if (firstLetterIndex === -1) {
                    return child;
                }

                hasCapitalizedFirstLetter = true;

                return capitalizeFirstLetter(child);
            }

            if (!isValidElement<PropsWithChildren>(child) || child.props.children == null) {
                return child;
            }

            return cloneElement(child, undefined, processChildren(child.props.children));
        });

    return processChildren(children);
};
